<template>

  <div>
    <div class="d-flex align-center">
      <v-icon icon="mdi-circle" class="mr-1" :class="mainStore.module.status == 'ouverte' ? 'pulse' : ''"
        :color="mainStore.module.status == 'ouverte' ? 'green-darken-4' : 'red-darken-4'"></v-icon>
      <div class="text-body-1 font-weight-bold">{{ mainStore.module.readable_status }}</div>
    </div>
    <div class="text-body-2 text-center">
      {{ mainStore.module.readable_status_details }}
    </div>
  </div>
</template>

<script>
import { useMainStore } from '@/stores/mainStore';
import { mapStores } from 'pinia';
export default {
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.pulse {
  animation: pulse-animation 2s infinite;
  border-radius: 50%;
}

@keyframes pulse-animation {
  0% {
    box-shadow: 0 -1px 0 0px rgba(3, 116, 8, 0.2);
  }

  100% {
    box-shadow: 0 -1px 0 10px rgba(3, 116, 8, 0);
  }
}
</style>